import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { Routes, Route } from 'react-router-dom';

import Welcome from './pages/Welcome';
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Organizations from './pages/Organizations';
import OrganizationDetails from './pages/Organizations/OrganizationDetails';
import ChargingPoints from './pages/ChargingPoints';
import Profile from './pages/Profile';
import ChargingStatus from './pages/ChargingStatus';
import StatusNotifications from './pages/StatusNotifications';
import History from './pages/History';
import ProtectedRoute from './protectedRoute';
import Sessions from './pages/Sessions';
import MeterReport from './pages/MeterReport';
import ChargeOrPay from './pages/ChargeOrPay';
import UserSession from './pages/UserSession';
import Providers from './pages/Providers';
import NotFound from './pages/NotFound';

import WithSideBar from './Components/NavBar/WithSideBar';
import WithoutSideBar from './Components/NavBar/WithoutSideBar';
import LoadingAnimation from './Components/Utils/BateryChargeAnimation';
import { setUser } from './redux/reducers/authSlice';

import { ROLES } from './Constants';
import { ThemeContext } from './Components/ThemeProvider';
import useGAPageview from './Utils/googleAnalitics.js';
import { setUserType } from './redux/reducers/userTypeSlice.js';
import { useLazyGetMeQuery, useLazyGetUserRoleQuery } from './redux/api/auth.js';

function AppRoutes() {
  const dispatch = useDispatch();
  const route = useLocation();

  const [getMe, meProfile] = useLazyGetMeQuery();
  const [getRole, userRole] = useLazyGetUserRoleQuery();

  useEffect(() => {
    getMe();
    if (meProfile.isSuccess) {
      dispatch(setUser(meProfile?.data?.userProfile));
      getRole(meProfile?.data?.userProfile.id);
      if (userRole.isSuccess) {
        dispatch(setUserType(userRole.data));
      }
    } else {
    }
  }, [meProfile.isSuccess, userRole.isSuccess]);

  useGAPageview(route.pathname);
  const { theme } = useContext(ThemeContext);
  return (
    <div id='theme-provider' className={theme}>
      <>
        {meProfile.isLoading && userRole.isLoading ? (
          <LoadingAnimation />
        ) : (
          <Routes>
            <Route element={<WithoutSideBar />}>
              <Route path='/' element={<Welcome />} />
            </Route>
            <Route element={<WithoutSideBar />}>
              <Route path='/register' element={<Register />} />
            </Route>
            <Route element={<WithoutSideBar />}>
              <Route path='/login' element={<Login />} />
            </Route>
            <Route element={<WithoutSideBar />}>
              <Route path='/charge/:cp_id/:connector_id' element={<ChargeOrPay />} />
            </Route>
            <Route element={<WithoutSideBar />}>
              <Route path='/session/:sessionId' element={<UserSession />} />
            </Route>

            <Route element={<ProtectedRoute type={ROLES.USER} />}>
              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/dashboard' element={<Dashboard />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/profile' element={<Profile />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/404' element={<NotFound />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute type={ROLES.USER} />}>
              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/users' element={<Users />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/charging-points' element={<ChargingPoints />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/charging-status' element={<ChargingStatus />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/history' element={<History />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/reports' element={<Reports />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/reports/sessions' element={<Sessions />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/reports/session' element={<MeterReport />} />
              </Route>

              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/providers' element={<Providers />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute type={[ROLES.SUPER_ADMIN, ROLES.ADMIN]} />}>
              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/status-notifications/:cp_id' element={<StatusNotifications />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute type={[ROLES.SUPER_ADMIN, ROLES.ADMIN]} />}>
              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/organizations' element={<Organizations />} />
                <Route exact path='/organizations/:id' element={<OrganizationDetails />} />
                <Route exact path='/organizations/create' element={<OrganizationDetails />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute type={ROLES.SUPER_ADMIN} />}>
              <Route element={<WithSideBar isAuthenticated={false} />}>
                <Route path='/providers' element={<Providers />} />
              </Route>
            </Route>
            <Route path='*' element={<Navigate to='/404' />} />
          </Routes>
        )}
      </>
    </div>
  );
}

export default AppRoutes;
